import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { trackEvent } from '../utils/metaPixel';
export function Bundle() {
  return <section id="oferta" className="py-20 md:py-32 bg-sage scroll-mt-24" data-id="element-12">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-13">
        <div className="text-center mb-12 md:mb-20" data-id="element-14">
          <FadeIn data-id="element-15">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-16">
              La Guía Maestra
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-17">
              Todo lo que necesitas para <em className="italic" data-id="element-18">sanar</em>.
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-12 items-center" data-id="element-19">
          {/* Visual */}
          <div className="lg:col-span-7 relative flex justify-center" data-id="element-20">
            <FadeIn className="relative z-10" data-id="element-21">
              <div className="aspect-[3/4] max-w-xs md:max-w-md mx-auto bg-cream shadow-2xl flex flex-col items-center justify-center p-8 md:p-12 border border-white/50 relative overflow-hidden" data-id="element-22">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/40 to-transparent pointer-events-none" data-id="element-23"></div>
                <span className="uppercase tracking-[0.3em] text-[10px] text-ink-light mb-8" data-id="element-24">
                  El Cambio Hormonal
                </span>
                <h3 className="font-serif text-3xl md:text-4xl text-center text-ink leading-tight mb-6 md:mb-8" data-id="element-25">
                  El Método
                  <br data-id="element-26" />
                  del 1%
                </h3>
                <div className="w-12 h-[1px] bg-sand mb-8" data-id="element-27"></div>
                <p className="text-xs uppercase tracking-widest text-ink-light text-center" data-id="element-28">
                  Tu guía al balance natural
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Copy & Pricing */}
          <div id="precio" className="lg:col-span-5 flex flex-col items-center lg:items-start text-center lg:text-left scroll-mt-32" data-id="element-29">
            <FadeIn delay={0.2} data-id="element-30">
              <h3 className="font-serif text-2xl md:text-3xl mb-5 md:mb-6 text-ink" data-id="element-31">
                El E-Book del Método del 1%
              </h3>

              <div className="flex flex-col items-center mb-2" data-id="element-32">
                <span className="inline-block uppercase tracking-[0.2em] text-[10px] text-sand-dark bg-sand/15 px-3 py-1.5 mb-3" data-id="element-33">
                  Oferta de Lanzamiento · 83% OFF
                </span>
                <span className="text-xl text-ink-light/50 line-through font-light" aria-label="precio anterior 37" translate="no" data-id="element-34">
                  <span data-id="element-35">$</span>
                  <span data-id="element-36">3</span>
                  <span data-id="element-37">7</span>
                </span>
              </div>

              <div className="mb-8 flex flex-col items-center" data-id="element-38">
                <span className="font-serif text-5xl md:text-6xl text-ink leading-none mb-3" aria-label="precio actual 6 punto 39" translate="no" data-id="element-39">
                  <span data-id="element-40">$</span>
                  <span data-id="element-41">6</span>
                  <span data-id="element-42">.</span>
                  <span data-id="element-43">3</span>
                  <span data-id="element-44">9</span>
                </span>
                <p className="text-sm text-ink-light uppercase tracking-widest" data-id="element-45">
                  Pago único. Acceso de por vida.
                </p>
              </div>

              <Button onClick={() => {
              trackEvent('AddToCart', {
                content_name: 'El Método del 1% - E-Book',
                content_ids: ['53815682957678'],
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
              window.location.assign('https://vuelveavivir.com/cart/53815682957678:1');
            }} className="w-full sm:w-auto" data-id="element-46">
                Obtener Acceso Inmediato
              </Button>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}